import { HttpClient, ListParams } from './http-client';
import Paginate from '../interfaces/paginate';
import { Observable } from 'rxjs';
import AnimalConfiguration, {
  AnimalConfigurationPair,
  AnimalGoalData,
} from '../interfaces/animal-configuration';

export class AnimalConfigurationService extends HttpClient {
  index(
    farmId: string,
    params?: ListParams
  ): Observable<Paginate<AnimalConfiguration>> {
    return this.get<Paginate<AnimalConfiguration>>(
      `/api/farms/${farmId}/livestock/animal-configuration`,
      params
    );
  }

  indexYield(
    farmId: string,
    params?: ListParams
  ): Observable<Paginate<AnimalConfiguration>> {
    return this.get<Paginate<AnimalConfiguration>>(
      `/api/farms/${farmId}/livestock/animal-configuration-yield`,
      params
    );
  }

  getTableData(farmId: string): Observable<boolean> {
    return this.get<boolean>(
      `/api/farms/${farmId}/livestock/animal-configuration-data`
    );
  }

  getConfigurations(farmId: string): Observable<AnimalConfigurationPair> {
    return this.get<AnimalConfigurationPair>(
      `/api/farms/${farmId}/livestock/animal-all-configurations`
    );
  }

  saveConfigurations(
    farmId: string,
    saveData: AnimalGoalData[]
  ): Observable<AnimalConfiguration> {
    return this.post<AnimalConfiguration>(
      `/api/farms/${farmId}/livestock/animal-save-configurations`,
      { saveData }
    );
  }
}
